export default "<div class=\"calendar-wrapper outerCalender-{{elementId}}\"></div>\n\n"